import { DataGridPageState } from './types';

const defaultNoOp = () => {
  console.warn(
    'Data grid page handler not implemented. Context should be used via the context provider.'
  );
};

export const defaultInitialDataGridPageState: DataGridPageState<any> = {
  asideState: 'read',
  isAsideOpen: false,
  isDeleteDialogOpen: false,
  shouldPromptDiscard: false,
  isDiscardDialogOpen: false,
  // Default no-op handlers
  onAdd: defaultNoOp,
  onEdit: (_row: any) => defaultNoOp(),
  onExport: (_row: any) => defaultNoOp(),
  onClickRow: (_row: any) => defaultNoOp(),
  onSelectMultiple: (_rows?: any[]) => defaultNoOp(),
  onDelete: (_row: any) => defaultNoOp(),
  onConfirmDelete: defaultNoOp,
  onCloseAside: defaultNoOp,
  onSaveAside: (_row: any) => defaultNoOp(),
  onCancelDelete: defaultNoOp,
  onChangeAside: (_dirty: boolean) => defaultNoOp(),
  onCancelDiscard: defaultNoOp,
  onConfirmDiscard: defaultNoOp,
  onNavigate: defaultNoOp,
  redirect: defaultNoOp,
  dispatch: defaultNoOp,
};
